import { call, getContext, put, select } from 'redux-saga/effects'
import { urls } from '../../routing'
import { setGuestSignUpScreenAction } from '../actions'
import { IStoreState } from '../states'
import { GuestSignUpScreen } from '../types/user-info'

// The auth screens that exist both as pages and inside the guest prompt. Resolved on use, not at
// import time: `urls` comes through the routing module, which imports the pages, and those reach
// back into the store — a module-level table could run before `urls` is populated.
function screenFor(url: string): GuestSignUpScreen | undefined {
  const screens: Record<string, GuestSignUpScreen> = {
    [urls.signIn]: 'signIn',
    [urls.signUpStep1]: 'signUp1',
    [urls.recoverPasswordRequestCodeStep]: 'recoverRequest',
    [urls.recoverPasswordRestoreStep]: 'recoverRestore',
    [urls.accountVerificationStep]: 'verification',
    [urls.accountVerificationResend]: 'verificationResend',
    [urls.newPasswordRequired]: 'newPassword'
  }
  return screens[url]
}

/**
 * Where the sign in / sign up / recover / verify sagas send the user next. On the pages that is a
 * route change; when the same flow is running inside the guest prompt, the prompt just moves to
 * the matching screen and the map stays where it is.
 */
export function* goToAuthScreen(url: string, replace = false): any {
  const { isGuest, showGuestSignUp } = yield select((state: IStoreState) => state.userInfo)
  const screen = screenFor(url)

  if (isGuest && showGuestSignUp && screen) {
    yield put(setGuestSignUpScreenAction(screen))
    return
  }

  const routerHistory = yield getContext('routerHistory')
  yield call(replace ? routerHistory.replace : routerHistory.push, url)
}
